import { makeSegmentTrackCall } from 'client/javascript/analytics';
import { BUILDINGS_NEAR_ME_EXPERIMENT } from './constants';

export const sendNearByBuildingExperimentEvent = value => {
  const bucketValue = value ? '2' : '1';
  makeSegmentTrackCall('Bucket', {
    bucket_type: 'experiment',
    bucket_value: bucketValue,
    label: BUILDINGS_NEAR_ME_EXPERIMENT
  });
};

export const sendNearByBuildingEvent = label => {
  makeSegmentTrackCall('Interation', {
    bucket_type: null,
    bucket_value: null,
    label
  });
};
